<template>
  <div>
    <helpers-section-header class="mt-6 mb-8"> WhaleIndex Signal Rules </helpers-section-header>

    <helpers-section-sub-header class="mt-6 mb-2"> Signal Evaluation: </helpers-section-sub-header>
    <v-row density="compact">
      <v-col v-if="!appcriteria.general.screener" cols="12">
        <v-text-field
          v-model="appcriteria.signals.whaleindex_signal.number_of_days_to_evaluate"
          label="Days to evaluate"
          suffix="days"
          variant="outlined"
          density="compact"
          hint="Number of days after filing released (plus trading delay) to continue to evaluate as a buy.  max allowed is 100"
          persistent-hint
          style="max-width: 250px"
        />
      </v-col>
    </v-row>

    <v-col cols="12" mb-2>
      <helpers-section-sub-header>Trading delay:</helpers-section-sub-header>
      <v-row density="compact">
        <v-col cols="12" sm="6" md="4" xl="3">
          <v-text-field
            v-model="appcriteria.signals.whaleindex_signal.trading_delay"
            type="number"
            suffix="days"
            variant="outlined"
            density="compact"
            hint="Days after 13F deadline before being considered for backtesting"
            persistent-hint
            class="pt-0"
          />
        </v-col>
      </v-row>
    </v-col>

    <v-table class="my-8">
      <thead>
        <tr>
          <th>WhaleIndex Portfolio</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="m in appcriteria.signals.whaleindex_signal.whale_indices"
          :key="m.whale_index_id"
        >
          <td class="py-4">
            <v-checkbox
              v-model="m.enabled"
              :label="m.name"
              color="primary"
              hide-details
              class="mt-0"
            />
          </td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.whaleindex_signal',
      enabled: 'app.whaleTraderCriteria.signals.whaleindex_signal.enabled',
      signalView: 'app.signalView'
    })
  }
}
</script>
